import {Platform, Text, View, StyleSheet,Button, Alert, Modal } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import Constants from 'expo-constants';


const ResourceMenu = (  ) => {

  const navigation = useNavigation();

  let misrecursos = (object) => {
    console.log("presionado");
    navigation.navigate("Mis recursos");
  }

  let descargar = (object) => {
    console.log("presionado");
    navigation.navigate("Descargar recursos");
  }

  return (
      <View>
        <Text>Versión movil: </Text>
        <Text/>
        <Button
                title= {"Mis Recursos"} 
                onPress= { misrecursos }
                onClick= { misrecursos }
            />
          <Text/>
          <Button
                title= {"Descargar recursos"} 
                onPress= { descargar }
                onClick= { descargar }
            />

      </View>
    );
      
 };
    

 export default ResourceMenu;